export default "__VITE_ASSET__74f5819d__"